import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workshop-cryptanalysis',
  templateUrl: './workshop-cryptanalysis.component.html',
  styleUrls: ['./workshop-cryptanalysis.component.css']
})
export class WorkshopCryptanalysisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
